import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import CustomDropdown from '../../components/CustomDropdown'

function Settings() {

    return (
        <>
            <h1>Settings:</h1>
            <Row>
                <Col className="col-6">
                    {/* <CustomDropdown ranges={[10, 25, 50, 100]}></CustomDropdown> */}
                    <input ></input>
                </Col>
                <Col className="col-6">
                </Col>
            </Row>
            
        </>
    )
  }
  
export default Settings
